import React from "react";
import { cable_length_options } from "../../../../../constants";
import eventEmitter from "../../eventEmitter";

function CableLength(props) {
    const { name, label, onChange, value, options, id } = props;

    const handleChange = (e) => {
        onChange(e);
        eventEmitter.emit("onCableLengthChange", {
            value: e.target.value,
            id: id,
        });
    };

    return (
        <div class="input-wrapper">
            <label htmlFor={name}>{label}</label>
            <select name={name} id={name} onChange={handleChange}>
                <option value={""} selected={value == ""}>
                    None
                </option>
                {options.split(",").map((key) => (
                    <option value={key} selected={value == key}>
                        {cable_length_options[key]}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default CableLength;
